export default __webpack_public_path__ + "static/media/popular_video.6b0cdaef.mov";